<template>
  <div>
    <Row style="margin:10px 0">
      <Col span="24">
        <Card>
          <slot name="buttonGroup" slot="title">
            <Row>
              <Col span="18">
                <ButtonGroup>
                  <Button
                    icon="md-add"
                    type="primary"
                    @click="CreateElement"
                    v-if="isRouter"
                  >{{routerAdd.text}}</Button>
                  <Button
                    icon="md-add"
                    type="primary"
                    v-if="isModal"
                    @click="modalShow"
                  >{{modalAdd.text}}</Button>
                  <Button
                    icon="ios-trash"
                    type="error"
                    :disabled="disabled"
                    @click="batchDeleteConfirm=true"
                    v-if="isDelete"
                  >批量删除</Button>
                </ButtonGroup>
              </Col>
              
            </Row>
          </slot>

          <div>
            <Table
              ref="tablesMain"
              :data="insideTableData"
              :columns="columns"
              :loading="loading"
              @on-selection-change="onSelectionChange"
              @on-sort-change="handleSort"
              border
              :height="height"
              disabled-hover
            ></Table>
          </div>
          <div class="margin-top-15" style="text-align: center" v-if="isPage">
            <Page
              :total="tableShow.listCount"
              :current="tableShow.currentPage"
              prev-text="上一页"
              next-text="下一页"
              :page-size="tableShow.pageSize"
              :page-size-opts="tableShow.pageOpts"
              show-elevator
              show-sizer
              show-total
              @on-change="handlePageChange"
              @on-page-size-change="handleSizeChange"
            ></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <Modal v-model="batchDeleteConfirm" :loading="delLoading" title="确认删除吗？" @on-ok="doDel">
      <Alert type="warning" show-icon>删除后将无法恢复数据</Alert>
    </Modal>

    <Modal v-model="singleDel" :loading="singleDelLoading" title="确认删除吗？" @on-ok="doSingleDel">
      <Alert type="warning" show-icon>{{singleDelMsg}}</Alert>
    </Modal>
    <!--单个删除（后台调用批量删除接口，传入参数不同）-->
    <Modal v-model="deleteModalShow" :loading="singleDelLoading" title="确认删除吗？" @on-ok="deleteModalFunction">
      <Alert type="warning" show-icon>{{singleDelMsg}}</Alert>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "DataTable",
  props: {
    // 异步请求url
    listUrl: {
      type: String
    },
    // 是否需要分页
    isPage: {
      type: Boolean,
      default: true
    },
    // url地址
    url: {
      type: String
    },
    //导出数据的地址
    exportUrl: {
      type: String
    },
    // 表头
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    // 搜索参数
    search: {
      type: Object,
      default() {
        return {};
      }
    },
    isRouter: {
      type: Boolean,
      default: false
    },
    routerAdd: {
      type: Object,
      default() {
        return { text: "新增" };
      }
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    modalAdd: {
      type: Object,
      default() {
        return { text: "新增" };
      }
    },
    // 头部按钮、新增及批量操作按钮
    toolsBtn: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      type: Number,
      default() {
        return 0;
      }
    },
    exportName: {
      type: String
    },
    exportMethod: {
      type: String,
      default: "get"
    },
    size: String,
    selectIdKey: {
      type: String,
      default: "id"
    },
    //是否立刻执行查询
    isSelect: {
      type: Boolean,
      default: true
    }
  },
  /**
   * Events
   * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
   * @on-cancel-edit 返回值 {Object} 同上
   * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
   */
  data() {
    return {
      deleteModalShow:false,
      exportDisabled: false,
      singleDelMsg: "是否确定删除该条数据？",
      length: 0, //记录每页过来的数据长度，做删除的时候是否进行当前页面数据保留使用
      disabled: true,
      start: false, // 显示导出进度条
      percent: 0, // 导出进度
      excelDisc: "数据准备中", // 导出描述
      batchDisabled: true,
      project_name: "", //项目名称 用于进展、档案、报告按钮右侧显示
      insideTableData: [],
      loading: true,
      batchDeleteConfirm: false,
      delSuccess: false,
      selectIds: "", // 多选
      singleid: "", // 单选删除
      delIndex: "", // 单选删除序号
      singleDelLoading: "",
      params: {}, // url 传过来的参数
      delReload: false, // 删除后是否需要重新加载数据
      singleDel: false,
      singleDelUrl: "",
      delLoading: "",
      submitData: {},
      tableShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0,
        pageOpts: [10, 30, 50, 100]
      },
      modalTitle: "",
      deleteModalIds:{}
    };
  },
  methods: {
    modalShow() {
      this.$emit("modalClick");
    },
    /**
     * 点击页码触发
     * @param  {[type]} page [description]
     * @return {[type]}      [description]
     */
    handlePageChange(page) {
      this.loading = true;
      this.tableShow.currentPage = page;
      this.$db.setPage(page);
      this.$db.setPageSize(this.tableShow.pageSize);
      this.$db.setSearch(this.search);
      this.$db.list(this.listUrl).then(resp => {
        this.insideTableData = resp.data.data;
        this.length = resp.data.data.length;
        this.loading = false;
      });
    },
    /**
     * 改变每页显示条数
     * @return {[type]} [description]
     */
    handleSizeChange(pageSize) {
      this.loading = true;
      this.tableShow.pageSize = pageSize;
      this.tableShow.currentPage = 1; // 每页条数切换后，当前页码置为1
      this.$db.setPage(1);
      this.$db.setPageSize(pageSize);
      this.$db.setSearch(this.search);
      this.$db.list(this.listUrl).then(resp => {
        this.insideTableData = resp.data.data;
        this.length = resp.data.data.length;
        this.loading = false;
        this.tableShow.listCount = resp.data.total;
      });
    },
    CreateElement() {
      this.$parent.CreateElement();
    },
    /**
     * 搜索触发
     * @return {[type]} [description]
     */
    handleSearch() {
      // 加载状态
      this.loading = true;
      // 搜索条件
      this.$db.setSearch(this.search);
      // 发起请求
      this.$db.list(this.listUrl).then(resp => {
        this.insideTableData = resp.data.data;
        this.length = resp.data.data.length;
        this.loading = false;
        this.tableShow.listCount = resp.data.total;
      });
    },
    /**
     * 排序
     * @param  {[type]} column [description]
     * @param  {[type]} key    [description]
     * @param  {[type]} order  [description]
     * @return {[type]}        [description]
     */
    handleSort(column) {
      this.loading = true;
      this.$db.setSearch(this.search);
      this.$db.setOrderBy(column.key);
      this.$db.setOrder(column.order);
      this.$db.list(this.listUrl, this.isPage).then(resp => {
        if (this.isPage) {
          this.insideTableData = resp.data.data;
          this.length = resp.data.data.length;
        } else {
          this.insideTableData = resp.data;
        }
        this.loading = false;
      });
    },
    /**
     * 多选操作
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelectionChange(selection) {
      // 多选，计算ID
      let selected = [];
      for (var key in selection) {
        selected.push(selection[key][this.selectIdKey]);
      }
      if (selected.length > 0) {
        this.disabled = false;
        this.batchDisabled = false;
        this.selectIds = selected;
      } else {
        this.disabled = true; // 禁用按钮
        this.batchDisabled = true;
        this.selectIds = "";
      }
    },

    /**
     * 批量删除-删除
     * @return {[type]} [description]
     */
    doDel() {
      this.delLoading = true;
    },

    /**
     * 新增弹窗
     * @param  {[type]} key [description]
     * @return {[type]}     [description]
     */
    showModal(key, title) {
      this.modalTitle = title;
      this.$refs.modal.show();
    },

    /**
     * 批量操作-弹框
     * @return {[type]} [description]
     */
    showBatchModal(key, title) {
      if (this.selectIds === "") {
        this.batchDisabled = true;
      } else {
        this.$parent.$data[key] = true;
        this.$parent.$data["modalTitle"] = title;

        // 打开弹窗之后的回调函数
        if (this.$parent.$data.modalCallBack) {
          this.$parent[this.$parent.$data.modalCallBackFunc]();
        }
      }
    },

    /**
     * 编辑信息
     */
    handEdit(id) {
      this.$db.get(this.url + "/" + id).then(res => {
        if (res) {
          console.log(res, "res");
          this.$emit("handEdit", res.data);
        } else {
          this.$Message.error("数据错误");
        }
      });
    },

    /**
     * 删除前置，弹出确认窗口
     */
    handleDel(id, reload = false) {
      this.singleid = id;
      this.singleDel = true;
    },

    /**
     * 额外的单个删除（调用批量删除的方法）
     */
    handleDeleteModal(params){
      this.deleteModalIds = params;
      this.deleteModalShow = true
    },

    deleteModalFunction(){
      this.$db.delete(this.url,this.deleteModalIds).then(res=>{
        if (res) {
          //删除成功，需要校验当前的页码数及数组长度 - 1，如果长度 -1 等于0，那么需要往上翻一页
          if (this.length - 1 == 0 && this.tableShow.currentPage != 1) {
            //表示当前页没有数据了，并且不是在第一页的话，需要往上翻一页
            this.tableShow.currentPage = this.tableShow.currentPage - 1;
          }
          this.loading = true;
          this.$db.setPage(this.tableShow.currentPage);
          this.$db.setPageSize(this.tableShow.pageSize);
          this.$db.setSearch(this.search);
          this.$db.list(this.listUrl).then(resp => {
            if (this.isPage) {
              this.insideTableData = resp.data.data;
              this.length = resp.data.data.length;
              this.tableShow.listCount = resp.data.total;
            } else {
              this.insideTableData = resp.data;
            }

            this.loading = false;
          });
          this.deleteModalShow = false;
          this.$Message.success("数据已成功删除！");
        }
      })
    },
    /**
     * 执行删除操作
     */
    doSingleDel() {
      this.$db.delete(this.url + "/" + this.singleid).then(res => {
        if (res) {
          //删除成功，需要校验当前的页码数及数组长度 - 1，如果长度 -1 等于0，那么需要往上翻一页
          if (this.length - 1 == 0 && this.tableShow.currentPage != 1) {
            //表示当前页没有数据了，并且不是在第一页的话，需要往上翻一页
            this.tableShow.currentPage = this.tableShow.currentPage - 1;
          }
          this.loading = true;
          this.$db.setPage(this.tableShow.currentPage);
          this.$db.setPageSize(this.tableShow.pageSize);
          this.$db.setSearch(this.search);
          this.$db.list(this.listUrl).then(resp => {
            if (this.isPage) {
              this.insideTableData = resp.data.data;
              this.length = resp.data.data.length;
              this.tableShow.listCount = resp.data.total;
            } else {
              this.insideTableData = resp.data;
            }

            this.loading = false;
          });
          this.singleDel = false;
          this.$Message.success("数据已成功删除！");
        }
      });
    },

    /**
     * 刷新数据，保持在当前页面
     */
    reloadData() {
      this.loading = true;
      if (this.isPage) {
        db.setPage(this.tableShow.currentPage);
        db.setPageSize(this.tableShow.pageSize);
        db.setSearch(this.search);
      }

      this.$db.list(this.listUrl, this.isPage).then(resp => {
        if (this.isPage) {
          this.insideTableData = resp.data.data;
          this.length = resp.data.data.length;
        } else {
          this.insideTableData = resp.data;
        }
        this.loading = false;
      });
      this.$Message.success("数据更新成功");
    },

    /**
     * 通过key:value
     * 进行单独字段的更新
     * reload 是否刷新表格
     */
    setValueByKeys(data, id, reload = false) {
      this.$db.put(this.url + "/" + id, data).then(res => {
        if (res) {
          if (reload) {
            this.reloadTable();
          }
          this.$Message.success("设置成功");
        } else {
          this.$Message.error("数据错误");
        }
      });
    },

    /**
     * 刷新表格
     */
    reloadTable() {
      // 加载状态
      this.loading = true;
      this.$db.setSearch(this.search);
      // 发起请求
      this.$db.list(this.listUrl, this.isPage).then(resp => {
        if (this.isPage) {
          this.insideTableData = resp.data.data;
          this.length = resp.data.data.length;
          this.tableShow.listCount = resp.data.total;
        } else {
          this.insideTableData = resp.data;
        }
        this.loading = false;
      });
    },


    routeTo(route) {
      let { name, params, query } = {};
      name = route.name;
      params = route.params;
      query = route.query;
      this.$router.push({
        name,
        params,
        query
      });
    }
  },
  mounted() {
    this.$db.setSearch(this.search);
    if (this.isSelect) {
      this.$db.list(this.listUrl, this.isPage).then(resp => {
        //console.log(resp,"resp")
        if (resp.data) {
          this.loading = false;
          if (this.isPage) {
            this.insideTableData = resp.data.data;
            this.length = resp.data.data.length;
            this.tableShow.listCount = resp.data.total;
          } else {
            this.insideTableData = resp.data;
          }
        }
      });
    }
  },
  watch: {
    insideTableData(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/dataTable.vue